export default "__VITE_ASSET__CeiBcEbI__"